import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import Select from "react-select";
import { ADR_EDIT } from "../../_constants/actionConstants";
import adrActions from "../../_actions/adrActions";
import { MAX_COLUMNS } from "./utils/adrUtilsV3";
import "./styles/addLaborCrewModal.css";
import BadgeContainer from "../_common/BadgeContainer";
import Badge from "../_common/Badge";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import laborCrewActions from "../../_actions/laborCrewActions";

class AddLaborCrewModalV3 extends Component {
  state = {
    selectedLaborCrew: null,
    selectedCustomLabors: [],
    laborCrewName: "",
    nameExists: false,
    laborHours: {}, // Normalized by wpTabId, see adrFactories.js
    selectedInputType: "preset",
    errors: {},
    wpSortOrder: [],
  };

  componentDidMount() {
    const { dispatch, tabId, workPerformedClient: wpc } = this.props;
    /** @type {WpSortOrder[]} */
    const wpSortOrder =
      wpc && Object.keys(wpc).length > 0
        ? dispatch(adrActions.getWorkPerformedSortOrder(tabId))
        : [];

    const laborHours = {}; // Initialize
    wpSortOrder.forEach((wpSo) => {
      laborHours[wpSo.wpTabId] = { wpTabId: wpSo.wpTabId, regHours: "", otHours: "" };
    });

    this.setState({ wpSortOrder, laborHours });
  }

  // Find the rowOrder to insert crews. Rule is to insert just below the last nonzero
  // labor's rowOrder. Trailing blank rows will be preserved.
  getInsertAt = () => {
    const { laborSetClient, laborSetOrder } = this.props;

    // If laborSetClient doesn't exist, insert at the top.
    if (!laborSetClient) return 0;

    // Set the default value to the last row.
    let insertAt = laborSetOrder.length;

    // Iterate laborSetClient rows bottom up until the first nonzero laborId is found.
    for (let i = laborSetOrder.length - 1; i >= 0; i--) {
      if (laborSetClient[laborSetOrder[i]].laborId !== 0) {
        insertAt = laborSetClient[laborSetOrder[i]].rowOrder + 1;
        break;
      }
      insertAt = i;
    }

    return insertAt;
  };

  handleChange_inputType = (e) => this.setState({ selectedInputType: e.target.name });

  handleChange_laborCrew = (selectedLaborCrew) => this.setState({ selectedLaborCrew });

  handleChange_laborCustom = (selectedCustomLabors) =>
    this.setState({ selectedCustomLabors });

  handleChange_laborCrewName = (e) => {
    const { dispatch, projectId } = this.props;
    this.setState({ laborCrewName: e.target.value });
    dispatch(laborCrewActions.nameExists(projectId, e.target.value || "")).then(
      (nameExists) => this.setState({ nameExists })
    );
  };

  handleChange_laborHours = (wpTabId) => (e) =>
    this.setState({
      laborHours: {
        ...this.state.laborHours,
        [wpTabId]: { ...this.state.laborHours[wpTabId], [e.target.name]: e.target.value },
      },
    });

  handleSubmit = (e) => {
    e.preventDefault();
    const {
      dispatch,
      tabId,
      projectId,
      projLaborList,
      projLaborCrewList,
      laborSetClient,
      toggleAddLaborCrewModal,
      updateTradesToDisable,
      user,
    } = this.props;
    const { selectedInputType, laborHours } = this.state;

    /**
     * Helper function to populate contractorId and tradeId for the selected labor.
     * @param {number} laborId
     * @returns {LaborSetRowClient}
     */
    const buildLaborSetRowData = (laborId) => {
      const labor = (projLaborList || []).find((l) => l.laborId === laborId);

      // Log the error, but do not return yet - error-case return value is created later.
      if (!labor) console.error("AddLaborCrewModalV3 - labor could not be found.");

      // Uniqueness of each laborSetRow is determined by the laborId-tradeId combo.
      // Therefore, if a labor with his/her defaultTradeTradeId already exists in laborSetClient,
      // a conflict exists - default behavior is to blank out the trade selector (with the
      // defaultTrade grayed out). Note, this will result in the newly added row's
      // laborHours to be disabled from editing, since no trade is selected (see
      // AdrLaborSetRowV3.) The user will be alerted to this, and in order to
      // conditionally render the alert, the 'entryExists' will be piggy-backed onto the
      // return value (which is expected to be of type LaborSetRowClient.)
      const entryExists = Object.values(laborSetClient).find(
        (lsr) => lsr.laborId === laborId && lsr.tradeId === labor.defaultTradeTradeId
      );

      return {
        laborId: labor ? laborId : 0,
        contractorId: labor ? labor.contractorId : 0,
        tradeId: labor ? (entryExists ? 0 : labor.defaultTradeTradeId) : 0,
        laborHours,
        entryExists,
      };
    };

    // Data containers needed for both preset and custom:
    let laborData = []; // Collects all the laborSetRows to be added
    let ttd = {}; // Collects trades to disable

    if (selectedInputType === "preset") {
      const { selectedLaborCrew } = this.state;
      const chosenLc = (projLaborCrewList || []).find(
        (lc) => lc.laborCrewId === selectedLaborCrew.value
      );
      if (!chosenLc) {
        console.error(
          `AddLaborCrewModalV3 - selected projLaborCrew (with id=${selectedLaborCrew.value}) ` +
            `could not be found.`
        );
        toggleAddLaborCrewModal();
        return;
      }

      // Each projLaborCrew only contains a list of laborIds, so we must iterate
      // through each laborId and query the labor from projLaborList to find the
      // contractorId and tradeId needed for populating laborSetClient.
      chosenLc.laborIds.forEach((laborId) => {
        const ld = buildLaborSetRowData(laborId);
        laborData.push(ld);
        if (ld.tradeId) ttd[laborId] = { toEnable: 0, toDisable: ld.tradeId };
      });
    } else if (selectedInputType === "custom") {
      const { selectedCustomLabors, laborCrewName, nameExists } = this.state;

      // First check if the supplied crew name already exists. If so, warn and
      // do not proceed to insert crew.
      if (!nameExists) {
        selectedCustomLabors.forEach((lo) => {
          const ld = buildLaborSetRowData(lo.value);
          laborData.push(ld);
          if (ld.tradeId) ttd[lo.value] = { toEnable: 0, toDisable: ld.tradeId };
        });
        // If user wishes to save the crew (and if the supplied crew name is unique):
        if (laborCrewName) {
          const newLaborCrewData = {
            projectId,
            crewName: laborCrewName,
            isBridgeCrew: false,
            createdOn: new Date(),
            createdByUserId: user.userId,
            laborIds: selectedCustomLabors.map((lo) => lo.value),
          };
          dispatch(laborCrewActions.add(newLaborCrewData));
        }
      }
    }

    const insertAt = this.getInsertAt();

    dispatch({ type: ADR_EDIT.LABORSET.ADD, tabId, insertAt, laborData });
    updateTradesToDisable(ttd);
    toggleAddLaborCrewModal();
  };

  renderCrewMembers = (laborIds) => {
    const { projLaborList } = this.props;
    return (
      <BadgeContainer>
        {laborIds.map((l, i) => {
          const labor = (projLaborList || []).find((lab) => lab.laborId === l);
          return (
            <Badge
              className="mr-1"
              key={`addLaborCrewLaborKey_${l}`}
              itemId={i}
              clickItem={() => {}}
              deleteItem={() => {}}
              label={labor ? labor.fullName : ""}
              showDelete={false}
            />
          );
        })}
      </BadgeContainer>
    );
  };

  renderLaborHours = () => {
    const { workPerformedClient: wpc } = this.props;
    const { laborHours, wpSortOrder } = this.state;

    let lhInputs = [];
    let colIndex = 0;

    // Render existing wp columns
    wpSortOrder.forEach((wpSo) => {
      const lh = laborHours[wpSo.wpTabId] || null;
      const isIdle = wpc[wpSo.wpTabId] ? wpc[wpSo.wpTabId].isIdle : false;

      lhInputs.push(
        <div
          key={`laborCrewHoursKey_rt_${colIndex}`}
          className={`labor-crew-hours-padding labor-crew-hours ${
            isIdle && "table-warning"
          }`}
        >
          <input
            className="form-control px-1"
            type="number"
            id={`laborCrewHoursId_rt_${colIndex}`}
            name={"regHours"}
            value={laborHours[wpSo.wpTabId] ? laborHours[wpSo.wpTabId].regHours : ""}
            onChange={this.handleChange_laborHours(wpSo.wpTabId)}
            autoComplete="off"
            disabled={!lh || isIdle}
          />
        </div>
      );
      colIndex++;
    });

    if (colIndex < MAX_COLUMNS) {
      for (let remCol = colIndex; remCol < MAX_COLUMNS; remCol++) {
        lhInputs.push(
          <div
            key={`laborCrewHoursKey_rt_${remCol}`}
            className="labor-crew-hours-padding labor-crew-hours"
          >
            <input
              className="form-control px-1"
              type="number"
              id={`laborCrewHoursId_rt_${remCol}`}
              name={"regHours"}
              value={""}
              autoComplete="off"
              disabled={true}
            />
          </div>
        );
      }
    }

    return lhInputs;
  };

  renderLaborOvertimeHours = () => {
    const { workPerformedClient: wpc } = this.props;
    const { laborHours, wpSortOrder } = this.state;

    let lhOtInputs = [];
    let colIndex = 0;

    wpSortOrder.forEach((wpSo) => {
      const lh = laborHours[wpSo.wpTabId] || null;
      const isIdle = wpc[wpSo.wpTabId] ? wpc[wpSo.wpTabId].isIdle : false;

      lhOtInputs.push(
        <div
          key={`laborCrewHoursKey_ot_${colIndex}`}
          className={`labor-crew-hours-padding labor-crew-hours ${
            isIdle && "table-warning"
          }`}
        >
          <input
            className="form-control px-1"
            type="number"
            id={`laborCrewHoursId_ot_${colIndex}`}
            name={"otHours"}
            disabled={isIdle || !lh}
            value={laborHours[wpSo.wpTabId] ? laborHours[wpSo.wpTabId].otHours : ""}
            onChange={this.handleChange_laborHours(wpSo.wpTabId)}
            autoComplete="off"
          />
        </div>
      );
      colIndex++;
    });

    if (colIndex < MAX_COLUMNS) {
      for (let remCol = colIndex; remCol < MAX_COLUMNS; remCol++) {
        lhOtInputs.push(
          <div
            key={`laborCrewHoursKey_ot_${remCol}`}
            className="labor-crew-hours-padding labor-crew-hours"
          >
            <input
              className="form-control px-1"
              type="number"
              id={`laborCrewHoursId_ot_${remCol}`}
              name="otHours"
              value={""}
              autoComplete="off"
              disabled={true}
            />
          </div>
        );
      }
    }

    return lhOtInputs;
  };

  renderLaborHoursHeader1 = (wpSortOrder = []) => {
    const { workPerformedClient: wpc } = this.props;
    let col = 0;
    let h1 = [];

    const className =
      "labor-crew-hours labor-crew-hours-padding " +
      "labor-crew-hours-heading-padding labor-crew-hours-heading";
    for (col = 0; col < wpSortOrder.length; col++) {
      if (wpc[wpSortOrder[col].wpTabId].isIdle) {
        h1.push(
          <div key={`th1_labor_hours_${col}`} className={`${className} table-warning`}>
            <span className="badge badge-danger">Idle</span>
          </div>
        );
      } else {
        h1.push(<div key={`th1_labor_hours_${col}`} className={className} />);
      }
    }
    if (col < MAX_COLUMNS) {
      for (let remCol = wpSortOrder.length; remCol < MAX_COLUMNS; remCol++) {
        h1.push(<div key={`th1_labor_hours_${remCol}`} className={className} />);
      }
    }

    return h1;
  };

  renderLaborHoursHeader2 = (wpSortOrder = []) => {
    const { workPerformedClient: wpc } = this.props;
    let col = 0;
    let h2 = [];

    const className =
      "labor-crew-hours labor-crew-hours-padding " +
      "labor-crew-hours-heading-padding labor-crew-hours-heading";
    for (col = 0; col < wpSortOrder.length; col++) {
      if (wpc[wpSortOrder[col].wpTabId].isIdle) {
        h2.push(
          <div key={`th2_labor_hours_${col}`} className={`${className} table-warning`}>
            <span>
              <b>{wpc[wpSortOrder[col].wpTabId].wpShortCaption}</b>
            </span>
          </div>
        );
      } else {
        h2.push(
          <div key={`th2_labor_hours_${col}`} className={className}>
            <span className="th-align-center">
              <b>{wpc[wpSortOrder[col].wpTabId].wpShortCaption}</b>
            </span>
          </div>
        );
      }
    }
    if (col < MAX_COLUMNS) {
      for (let remCol = wpSortOrder.length; remCol < MAX_COLUMNS; remCol++) {
        h2.push(<div key={`th2_labor_hours_${remCol}`} className={className} />);
      }
    }

    return h2;
  };

  renderLaborHeader = (wpSortOrder = []) => {
    const h1 = (
      <div key="th1_labor" className="d-flex flex-row">
        <div
          key="th1_labor_time_type"
          className="labor-crew-hours-padding labor-crew-hours-time-type"
        ></div>
        {this.renderLaborHoursHeader1(wpSortOrder)}
      </div>
    );

    const h2 = (
      <div key="th2_labor" className="d-flex flex-row">
        <div
          key="th2_labor_time_type"
          className="labor-crew-hours-padding labor-crew-hours-time-type"
        ></div>
        {this.renderLaborHoursHeader2(wpSortOrder)}
      </div>
    );

    return [h1, h2];
  };

  render() {
    const {
      laborOptions,
      showAddLaborCrewModal,
      toggleAddLaborCrewModal,
      projLaborCrewList,
    } = this.props;
    const {
      selectedLaborCrew,
      selectedInputType,
      selectedCustomLabors,
      laborCrewName,
      nameExists,
      errors,
      wpSortOrder,
    } = this.state;
    const closeBtn = (
      <button className="close" onClick={toggleAddLaborCrewModal}>
        <FontAwesomeIcon icon="times" className="fa-fw text-white" />
      </button>
    );
    return (
      <Modal
        isOpen={showAddLaborCrewModal}
        toggle={toggleAddLaborCrewModal}
        className={this.props.className}
        fade={false}
        size={"lg"}
      >
        <ModalHeader
          toggle={toggleAddLaborCrewModal}
          className="bg-info text-white"
          close={closeBtn}
        >
          <FontAwesomeIcon icon="users" className="fa-fw mr-2" />
          Add Labor Crew
        </ModalHeader>
        <ModalBody>
          <div className="card">
            <div className="card-body">
              <div className="form-row">
                <div className="col-sm-3">
                  <div className="form-check-inline custom-control custom-radio mt-1 ml-2">
                    <div className="radio">
                      <input
                        type="radio"
                        name="preset"
                        id="preset"
                        checked={selectedInputType === "preset"}
                        onChange={this.handleChange_inputType}
                        className="custom-control-input"
                      />
                      <label htmlFor="preset" className="custom-control-label my-auto">
                        <b>Preset:</b>
                      </label>
                    </div>
                  </div>
                </div>
                <div className="col-sm-9">
                  <div className="form-group mb-0">
                    <Select
                      name="presetSelect"
                      id="presetSelect"
                      value={selectedLaborCrew}
                      options={(projLaborCrewList || []).map((lc) => ({
                        value: lc.laborCrewId,
                        label: lc.crewName,
                      }))}
                      onChange={this.handleChange_laborCrew}
                      isDisabled={selectedInputType !== "preset"}
                    />
                    {errors.preset && (
                      <span className="error-small">
                        <small>{errors.preset}</small>
                      </span>
                    )}
                    {selectedLaborCrew && selectedInputType === "preset" && (
                      <React.Fragment>
                        <p className="mb-1">
                          <small>Following labors will be added:</small>
                        </p>
                        {projLaborCrewList
                          ? this.renderCrewMembers(
                              (projLaborCrewList || []).find(
                                (lc) => lc.laborCrewId === selectedLaborCrew.value
                              ).laborIds
                            )
                          : ""}
                      </React.Fragment>
                    )}
                  </div>
                </div>
              </div>
              <hr className="my-2" />
              <div className="form-row">
                <div className="col-sm-3">
                  <div className="form-check-inline custom-control custom-radio mt-1 ml-2">
                    <div className="radio">
                      <input
                        type="radio"
                        name="custom"
                        id="custom"
                        checked={selectedInputType === "custom"}
                        onChange={this.handleChange_inputType}
                        className="custom-control-input"
                      />
                      <label htmlFor="custom" className="custom-control-label my-auto">
                        <b>Custom:</b>
                      </label>
                    </div>
                  </div>
                </div>
                <div className="col-sm-9">
                  <div className="form-group mb-0">
                    <Select
                      name="customSelect"
                      id="customSelect"
                      value={selectedCustomLabors}
                      options={laborOptions || []}
                      onChange={this.handleChange_laborCustom}
                      placeholder="(Select or Type)"
                      isMulti
                      isSearchable
                      isClearable
                      isDisabled={selectedInputType !== "custom"}
                    />
                    {errors.custom && (
                      <span className="error-small">
                        <small>{errors.custom}</small>
                      </span>
                    )}
                  </div>
                  <div className="form-row form-group mb-0 mt-2">
                    <label htmlFor="laborCrewName" className="col-sm-4 col-form-label">
                      Save as (optional):
                    </label>
                    <div className="col-sm-8">
                      <input
                        type="input"
                        name="laborCrewName"
                        id="laborCrewName"
                        className="form-control"
                        value={laborCrewName}
                        maxLength="100"
                        onChange={this.handleChange_laborCrewName}
                        disabled={selectedInputType !== "custom"}
                      />
                    </div>
                  </div>
                  {nameExists && (
                    <div className="alert alert-danger mt-2 mb-0 p-2">
                      <div className="d-flex flex-row">
                        <div className="mr-2">
                          <FontAwesomeIcon icon="exclamation-triangle" />
                        </div>
                        <div>
                          This crew name already exists. Provide a unique name for this
                          crew.
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="card mt-2">
            <div className="card-body">
              <h5 className="text-muted">Crew Hours (optional)</h5>
              <div className="d-flex flex-column w-75">
                {this.renderLaborHeader(wpSortOrder)}
                <div className="d-flex flex-row">
                  <div className="labor-crew-hours-padding labor-crew-hours-time-type">
                    <span className="badge badge-info px-1 mb-2">RT</span>
                  </div>
                  {this.renderLaborHours()}
                </div>
                <div className="d-flex flex-row">
                  <div className="labor-crew-hours-padding labor-crew-hours-time-type">
                    <span className="badge badge-warning px-1 mb-2">OT</span>
                  </div>
                  {this.renderLaborOvertimeHours()}
                </div>
              </div>
            </div>
          </div>
        </ModalBody>
        <ModalFooter className="bg-lightgray">
          <button
            type="button"
            id="addLaborCrew"
            name="addLaborCrew"
            className="btn btn-primary"
            onClick={this.handleSubmit}
            disabled={
              nameExists ||
              (selectedInputType === "preset" && selectedLaborCrew === null) ||
              (selectedInputType === "custom" &&
                (!selectedCustomLabors || selectedCustomLabors.length === 0))
            }
          >
            Add
          </button>{" "}
          <button
            type="button"
            id="cancelAddLaborCrew"
            name="cancelAddLaborCrew"
            className="btn btn-secondary"
            onClick={toggleAddLaborCrewModal}
          >
            Cancel
          </button>
        </ModalFooter>
      </Modal>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  user: state.authentication.user,
  projLaborList: state.labors.projLaborLists[ownProps.projectId] || null,
  projLaborCrewList: state.laborCrews.projLaborCrewLists[ownProps.projectId] || null,
  laborSetClient: state.adr.openAdrs[ownProps.tabId]
    ? state.adr.openAdrs[ownProps.tabId].laborSetClient || null
    : null,
  laborSetOrder: state.adr.openAdrs[ownProps.tabId]
    ? state.adr.openAdrs[ownProps.tabId].laborSetOrder || []
    : [],
  workPerformedClient: state.adr.openAdrs[ownProps.tabId]
    ? state.adr.openAdrs[ownProps.tabId].workPerformedClient || null
    : null,
});

export default connect(mapStateToProps)(AddLaborCrewModalV3);
